/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState, useEffect, useRef } from 'react'
import { VFScreen, HeaderTabs, TabView, VFHeader, Icon } from '@vfgroup-oneplatform/foundation/Components'
import PropTypes from 'prop-types'

import OfferList from '../../Containers/Catalogue'
import VFLoader from '../../Components/VFLoader'
import VfText from '../../Components/VfText'
import VFButton from '../../Components/VFButton'
import Modal from '../../Components/Modal'
import { isNonEmptyArray } from '../../Utils'

import styles from './CatalogueScreen.Styles'
import { Images } from '../../Themes'
import { useTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import { Platform, Dimensions, View } from 'react-native'
import _Modal from '../../../../react-native-modal'
import { useRoute } from '@react-navigation/native';

function CatalogueScreen({
  isContentLoading,
  loading,
  data,
  error,
  onClose,
  retry,
  maxNumOfRetries,
  onOfferPress,
  vfScreenProps = {},
  navigation,
  shouldSHowModal,
  setShouldShowModal,
  ...props
}) {
  const retries = useRef({
    count: 0,
    maxReached: false,
  })

  const [activeTab, setActiveTab] = useState(props.activeTab || 0)
  const [isError, setError] = useState(false)
  const [tabs, setTabs] = useState()
  const theme = useTheme()
  const { name: Name } = useRoute()

  useEffect(() => {
    if (props.activeTab) {
      setTimeout(() => {
        setActiveTab(props.activeTab)
      }, 50)
    }
  }, [props.activeTab])

  useEffect(() => {
    if (Array.isArray(data) && data.length > 0) {
      setTabs(data.map(({ id, name }, index) => ({ key: id, tab_key: name, index })))
    }
  }, [data])

  const closeError = () => { setError(false) }

  useEffect(() => {
    setError(Boolean(error))
  }, [error])

  const tryAgain = () => {
    retries.current.count += 1
    if (retries.current.count >= maxNumOfRetries) {
      retries.current.maxReached = true
    }
    retry()
  }

  const tabsContent = useMemo(() => {

    if (isContentLoading || loading) {
      return (
        <VFLoader style={styles.loader} containerStyle={styles.loaderContainer} />
      )
    }

    if (Array.isArray(data)) {
      return data.map((category, index) => (
        <TabView index={index}>
          <OfferList data={category} onOfferPress={onOfferPress} />
        </TabView>
      ))
    }

    return null
  }, [tabs, error, isContentLoading, loading])

  if (Platform.OS === 'web' && Dimensions.get('window').width > 700) {
    return (
      <VFScreen
        {...vfScreenProps}
        withHeader={false}
        setShouldShowModal={setShouldShowModal}
      >
        <VFHeader
          title={'catalogue_title_screen'}
          onClose={onClose}
          configureHeaderTabs={(!isContentLoading && !loading && isNonEmptyArray(tabs)) ? { activeTab, setActiveTab, tabs } : undefined}
          headerStyle={styles.headerStyle}
        />
        <HeaderTabs activeTab={activeTab}>
          {tabsContent}
        </HeaderTabs>
        <_Modal
          isVisible={isError && shouldSHowModal}
          close={closeError}
          onBackdropPress={() => { }}
          contentContainerStyle={styles.modalContainer}
          swipeDirection={undefined}
        >
          <View style={styles.modalView(theme)}>
            <Icon name={Images.error} type="image" size={54} resizeMode="contain" style={styles.icon} />
            <VfText i18nKey="catalogue_label_something_went_wrong" size="h3" weight="bold" align="center" />
            <VfText i18nKey={error} align="center" style={styles.description} />
            <VFButton
              title={retries.current.maxReached ? 'catalogue_action_retry_later' : 'catalogue_action_retry'}
              onPress={tryAgain}
              disabled={retries.current.maxReached}
            />
            <VFButton
              style={styles.secondaryButton}
              title="catalogue_action_go_back"
              onPress={onClose}
              type="secondary"
            />
          </View>
        </_Modal>
      </VFScreen>
    )
  }

  return (
    <VFScreen
      {...vfScreenProps}
      withHeader={false}
      setShouldShowModal={setShouldShowModal}
    >
      <VFHeader
        title={'catalogue_title_screen'}
        onClose={onClose}
        configureHeaderTabs={(!isContentLoading && !loading && isNonEmptyArray(tabs)) ? { activeTab, setActiveTab, tabs } : undefined}
        headerStyle={styles.headerStyle}
      />
      <HeaderTabs activeTab={activeTab}>
        {tabsContent}
      </HeaderTabs>
      <Modal
        isVisible={isError}
        close={closeError}
        onBackdropPress={() => { }}
        contentContainerStyle={styles.modalContainer(theme)}
        swipeDirection={undefined}
      >
        <Icon name={Images.error} type="image" size={54} resizeMode="contain" style={styles.icon} />
        <VfText color={theme.colors.textColor} i18nKey="catalogue_label_something_went_wrong" size="h3" weight="bold" align="center" />
        <VfText color={theme.colors.textColor} i18nKey={error} align="center" style={styles.description} />
        <VFButton
          title={retries.current.maxReached ? 'catalogue_action_retry_later' : 'catalogue_action_retry'}
          onPress={tryAgain}
          disabled={retries.current.maxReached}
        />
        <VFButton
          style={styles.secondaryButton}
          title="catalogue_action_go_back"
          onPress={onClose}
          type="secondary"
        />
      </Modal>
    </VFScreen>
  )
}

CatalogueScreen.defaultProps = {
  retry: () => { },
  maxNumOfRetries: 3,
  onClose: () => { },
  onOfferPress: () => { },
}

CatalogueScreen.propTypes = {
  isContentLoading: PropTypes.bool,
  loading: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.object),
  productImages: PropTypes.arrayOf(PropTypes.shape({
    uri: PropTypes.string,
  })),
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  retry: PropTypes.func,
  maxNumOfRetries: PropTypes.number,
  onClose: PropTypes.func,
  onOfferPress: PropTypes.func,
  vfScreenProps: PropTypes.object,
}

export default CatalogueScreen
